import { render, staticRenderFns } from "./StatusTable.vue?vue&type=template&id=3452b00e&scoped=true&"
import script from "./StatusTable.vue?vue&type=script&lang=js&"
export * from "./StatusTable.vue?vue&type=script&lang=js&"
import style0 from "./StatusTable.vue?vue&type=style&index=0&id=3452b00e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3452b00e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VDataTable})
